<template>
  <cst-page-template :hide-menu="true">
    <header-menu />
    <div class="faq-page">
      <div class="faq-page__header">
        <h1>FAQ</h1>
      </div>
      <loader v-if="isLoading" />
      <p v-else-if="!faqs.length" class="faq-page__empty">
        Er zijn nog geen veelgestelde vragen beschikbaar.
      </p>
      <ul v-else class="faq-list">
        <li
          v-for="faq in faqs"
          :key="faq.id"
          class="faq-item"
          :class="{ 'faq-item--open': openId === faq.id }"
        >
          <button class="faq-item__question" @click="toggle(faq.id)">
            <span>{{ faq.question }}</span>
            <span class="faq-item__chevron">&#x276F;</span>
          </button>
          <div v-show="openId === faq.id" class="faq-item__answer">
            <p>{{ faq.answer }}</p>
          </div>
        </li>
      </ul>
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import FaqApi from '@/api/server/Faq.api.js'

export default {
  components: { CstPageTemplate, HeaderMenu, Loader },
  data() {
    return { faqs: [], isLoading: false, openId: null }
  },
  async mounted() {
    this.isLoading = true
    try {
      const response = await FaqApi.getAllFaqs()
      this.faqs = response.data || []
    } catch {
      // silently fail — empty state already handled
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    toggle(id) {
      this.openId = this.openId === id ? null : id
    },
  },
}
</script>

<style lang="scss" scoped>
.faq-page {
  width: 100%;
  max-width: 760px;

  &__header {
    padding: 1.5rem 1.5rem 0;
    margin-bottom: 1.5rem;

    h1 {
      margin: 0;
      font-size: 1.75rem;
      color: $gray-darker;
    }
  }

  &__empty {
    padding: 0 1.5rem;
    color: $gray-dark;
  }
}

.faq-list {
  list-style: none;
  margin: 0;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.faq-item {
  border: 1px solid $gray-base;
  border-radius: 4px;
  overflow: hidden;

  &--open .faq-item__chevron {
    transform: rotate(90deg);
  }
}

.faq-item__question {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1rem;
  background: $gray-lightest;
  border: none;
  text-align: left;
  font-size: 0.95rem;
  font-weight: $font-weight-bold;
  color: $gray-darker;
  cursor: pointer;
  gap: 1rem;

  &:hover {
    background: $gray-lighter;
  }
}

.faq-item__chevron {
  display: inline-block;
  transition: transform 0.2s ease;
  font-size: 0.75rem;
  flex-shrink: 0;
  opacity: 0.6;
}

.faq-item__answer {
  padding: 0.9rem 1rem;
  font-size: 0.9rem;
  color: $gray-darker;
  line-height: 1.6;
  border-top: 1px solid $gray-base;
  background: white;

  p {
    margin: 0;
    white-space: pre-wrap;
  }
}
</style>
